module.exports = __webpack_public_path__ + "static/media/logo3.d42aeda8.png";